<div class="location-container">
  <div class="empty-state">
    <div><img src="assets/location-empty-state.svg"></div>
    <div class="empty-state-title">
      <p>There is no location available yet!</p>
    </div>
    <div class="empty-state-message">
      <p>Will be available soon. We do our best to provide you with the best experience.</p>
    </div>
  </div>
</div>
